import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TipoAlertaEnum } from '@modules/gestao-alertas/models/alerta';

@Component({
  selector: 'app-alerta-fixo',
  templateUrl: './alerta-fixo.component.html',
  styleUrls: ['./alerta-fixo.component.scss']
})
export class AlertaFixoComponent implements OnInit {

  @Input() alert: any;
  @Input() type: any;
  @Input() message = '';
  @Input() closable = false;
  @Input() linkLabel?: string;
  @Input() linkUrl?: string;

  @Output() submitEvent = new EventEmitter<any>();


  tipoAlertaEnum = TipoAlertaEnum
  closeAlerta: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  getStyleClass() {
    switch (this.alert?.alertType) {
      case this.tipoAlertaEnum.Alerta:
        return 'alerta-alerta'
        break;
      case this.tipoAlertaEnum.Informacao:
        return 'alerta-informacao'
        break;
      case this.tipoAlertaEnum.Sucesso:
        return 'alerta-sucesso'
        break;
      case this.tipoAlertaEnum.Erro:
        return 'alerta-erro'
        break;
    }
  }

  getIconClass() {
    switch (this.alert?.alertType) {
      case this.tipoAlertaEnum.Alerta:
        return 'uil uil-exclamation-triangle yellow'
      case this.tipoAlertaEnum.Informacao:
        return 'uil uil-info-circle blue'
      case this.tipoAlertaEnum.Sucesso:
        return 'uil uil-check-circle green'
      case this.tipoAlertaEnum.Erro:
        return 'uil uil-times-circle red'
    }
  }

  closeAlert() {
    this.closeAlerta = !this.closeAlerta;
  }

  onSubmit() {
    this.submitEvent.emit(this.alert)
  }
}
